document.addEventListener('DOMContentLoaded', function() {
  const stickyButton = document.getElementById('sticky-add-to-cart');
  const mainButton = document.querySelector('.product-form__submit');
  const productForm = document.getElementById('productFORM');

  if (!stickyButton || !mainButton || !productForm) return;

  function checkVisibility() {
    const productFormRect = productForm.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Si le formulaire est en dehors de la vue (en haut), on affiche le bouton sticky
    if (productFormRect.bottom < 0) {
      stickyButton.classList.remove('hidden');
    } else {
      stickyButton.classList.add('hidden');
    }
  }

  // Vérifier au chargement
  checkVisibility();

  // Vérifier au scroll
  window.addEventListener('scroll', checkVisibility);

  // Vérifier au redimensionnement de la fenêtre
  window.addEventListener('resize', checkVisibility);
});
